/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_FogInputs */

const en_ui_weather_fog = /** @type {(inputs: Ui_Weather_FogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fog`)
};

const de_ui_weather_fog = /** @type {(inputs: Ui_Weather_FogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebel`)
};

/**
* | output |
* | --- |
* | "Fog" |
*
* @param {Ui_Weather_FogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_fog = /** @type {((inputs?: Ui_Weather_FogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_FogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_fog(inputs)
	return de_ui_weather_fog(inputs)
});